import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
// import {Button} from "react-bootstrap";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
// import Link from '@material-ui/core/Link';
// import Grid from '@material-ui/core/Grid';
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Redirect } from "react-router";
import fontb from '../../btitr.ttf';
import ReactFontFace from 'react-font-face'
import logo1 from "../../assets/img/etela.png"
import logo2 from "../../assets/img/ihcs.png"
import { Row ,Col} from 'react-bootstrap';
import Grid from '@material-ui/core/Grid';
import { createMuiTheme, ThemeProvider,StylesProvider } from '@material-ui/core/styles';
// import { , ThemeProvider } from "@material-ui/styles";
import { create } from "jss";
import rtl from "jss-rtl";
import { jssPreset } from "@material-ui/core/styles";
import RTL from "layouts/Dashboard";
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const theme4 = createMuiTheme({
  typography: { useNextVariants: true },
  direction: "rtl"
});
// import {
//   BrowserView,
//   MobileView,
//   isBrowser,
//   isMobile
// } from "react-device-detect";
let theme2 = createMuiTheme();

theme2.typography.h3 = {
  fontSize: '1rem',
  '@media (min-width:600px)': {
    fontSize: '1.5rem',
  },
  [theme2.breakpoints.up('md')]: {
    fontSize: '2.8rem',
  },
};
theme2.typography.h2 = {
  // fontSize: '1.6rem',
  // '@media (min-width:100px)': {
    // fontSize: 14,
  // },
  // [theme2.breakpoints.down('lg')]: {
  //   fontSize: 19,
  // },
  // [theme2.breakpoints.up('xl')]: {
  //   fontSize: 19,
  // },
  [theme2.breakpoints.up('md')]: {
    fontSize: 19,
  },
  // [theme2.breakpoints.up('xs')]: {
    // fontSize: 1,
  // },
  [theme2.breakpoints.down('sm')]: {
    fontSize: 11,
  },
};
// function Copyright() {
// return (
// <Typography variant="body2" color="textSecondary" align="center">
//     {'Copyright © '}
//     <Link color="inherit" href="https://material-ui.com/">
//         Your Website
//     </Link>{' '}
//     {new Date().getFullYear()}
//     {'.'}
// </Typography>
// );
// }

// const useStyles = makeStyles((theme) => ({
//     paper: {
//         marginTop: theme.spacing(8),
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//     },
//     avatar: {
//         margin: theme.spacing(1),
//         backgroundColor: theme.palette.secondary.main,
//     },
//     form: {
//         width: '100%', // Fix IE 11 issue.
//         marginTop: theme.spacing(1),
//     },
//     submit: {
//         margin: theme.spacing(3, 0, 2),
//     },
// }));
let fontConfig = {

  file: [
    {
      fontFamily: 'Bangers',
      fontStyle:  'normal',
      fontWeight: 400,
      // unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215',
      file: fontb,
      fontType: 'truetype',
      fileLocal: 'Bangers Regular'
    },
    
  
  ]
}
 class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      UserName: "",
      Password: "",
      reset:false,
      user_level:"",
      token: "",
      signup:false,
      classes: makeStyles((theme) => ({
        paper: {
          marginTop: theme.spacing(8),
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "rgb(179,7,83)",
        },
        avatar: {
          color: "#3f51b5",
          // margin: theme.spacing(1),
          // marginLeft:'1000px',
          // backgroundColor: '#f44336',
        },
        form: {
          width: "100%", // Fix IE 11 issue.
          marginTop: theme.spacing(1),
        },
        submit: {
          margin: theme.spacing(3, 0, 2),
        },
      })), 
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    
  }
  
  handleChange(event) {
    this.setState({ UserName: event.target.value });
  }

  handleChange1(event) {
    this.setState({ Password: event.target.value });
  }

  // login() {
  //     // Call our fetch function below once the component mounts
  //     this.callBackendAPI()
  //         .then(res => this.setState({data: res}))
  //         .catch(err => console.log(err));
  // }
  //
  // // Fetches our GET route from the Express server. (Note the route we are fetching matches the GET route from server.js
  // callBackendAPI = async () => {
  //     const response = await fetch('/login');
  //     const body = await response.json();
  //     console.log(body);
  //     if (response.status !== 200) {
  //         throw Error(body.message)
  //     }
  //     return body;
  // };

  // componentDidMount() {
  //     const { classes } = useStyles();
  // }
  // const classes = useStyles();
  render() {
    // const { classes } = useStyles();
    return (
      // <BrowserView>
      <StylesProvider jss={jss}>
      <ThemeProvider theme={theme4}>
      <div style={{  display: 'flex', justifyContent: "center",marginTop:'5%'}}>
        <div style={{width:"60%",border:'1px solid black',borderRadius:"1%"}}>
      <Grid Container fluid  style={{justifyContent: 'row', display: "flex",backgroundColor: "rgb(44,71,76)" ,width:"100%"}}>
      <Grid item xs={4} sm={4} md={4} lg={4} >
      <img src={logo1} style={{width:'100%'}}/>
        </Grid>
        {/* <div style={{width:"15%",height:"10vh"}}> */}
        <Grid item xs={12} sm={12} md={12} lg={12} >
    <ThemeProvider theme={theme2} >
      <Typography variant="h3" style={{height:"30%", textAlign:"center", fontFamily:'Bangers',marginTop:"6%",color:"rgb(255,255,255)"}}> سامانه تحلیل مقالات علمی
</Typography>
    </ThemeProvider>
        {/* <div style={{ fontSize: 50,textAlign:"center", fontFamily:'Bangers',backgroundColor:"black"}}> */}
             {/* </div>  */}
        </Grid>
        <Grid item xs={3} sm={3} md={3} lg={3} >
        <img  src={logo2} style={{width:'100%'}}/>
        </Grid>

        {/* </div> */}
        {/* <div style={{width:"85%"}}> */}

             
        {/* </div> */}
        {/* <div style={{width:"15%"}}> */}
        

        {/* </div> */}
        
          </Grid>
          <div style={{height:".001%",border:'1px solid black'}}>

          </div>
          <ThemeProvider theme={theme2} >
      <Typography variant="h3" style={{ textAlign:"center", fontFamily:'Bangers',marginTop:"5%"}}>               ورود به سامانه
</Typography>
    </ThemeProvider>
          {/* <div style={{ marginTop:"5%",width:"100%",height:"auto",textAlign: "center", fontSize: 40, fontFamily:'Bangers'}}>
              ورود به سامانه
          </div> */}
      <Container  component="main" maxWidth="xs" style={{height:'auto'}}>
        <CssBaseline />
        
        <div className={this.state.classes.paper} style={{marginTop:"10%",height:'auto'}}>
          
          {/* <Avatar
            style={{
              color: "#fffdf8",
              backgroundColor: "rgb(179,7,83)",
              marginLeft: "45%",
              marginTop: "30%",
            }}
          > */}
            {/* <LockOutlinedIcon />
          </Avatar> */}

          {/*<Typography component="h1" variant="h5">*/}
          {/*    Sign in*/}
          {/*</Typography>*/}
          <form className={this.state.classes.form} noValidate >
            <TextField 
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="ایمیل"
              name="email"
              style={{direction:'rtl'}}
              autoComplete="email"
              onChange={this.handleChange}
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              style={{direction:'rtl'}}
              label="رمز عبور"
              type="password"
              id="password"
              onChange={this.handleChange1}
              autoComplete="current-password"
            />
            {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="مرا به خاطر بس\ار"
            /> */}
            {/*<Button*/}
            {/*    type="submit"*/}
            {/*    fullWidth*/}
            {/*    variant="contained"*/}
            {/*    color="primary"*/}
            {/*    className={this.state.classes.submit}*/}
            {/*    onClick={() => this.sendLoginData()}*/}
            {/*>*/}
            {/*    Sign In*/}
            {/*</Button>*/}
            <Button
              fullWidth
              
              className="button"
              style={{fontFamily:'Bangers',fontSize:20 ,backgroundColor: "rgb(44,71,76)",color:"rgb(255,255,255)" }}
              onClick={() => this.sendLoginData()}
            >
              ورود
            </Button>
            {/* <div style={{flexDirection: "column", display: "flex"}}> */}
            {/* </view> */}
            
            <view fullWidth style={{alignItems: 'center',justifyContent:"center",display: 'flex'}}>
            <ThemeProvider theme={theme2} >
      <Typography variant="h2" style={{ textAlign:"center",fontWeight:'bold', fontFamily:'Bangers',marginTop:"6%"}}>article.analysis@ihcs.ac.ir :تماس با ما
</Typography>
    </ThemeProvider>
      
            </view>
            <view fullWidth style={{alignItems: 'flex-start',display: 'flex'}}>
            <Button
              
              
              className="button"
              style={{fontFamily:'Bangers',fontSize:17 ,textAlign:"right", marginLeft: 'auto' }}
              onClick={() => this.SignUp()}
            >
ثبت نام            </Button>
            </view>
            
            <view fullWidth style={{alignItems: 'flex-start',display: 'flex'}}>
            <Button
              
              
              className="button"
              style={{fontFamily:'Bangers',fontSize:17 ,textAlign:"right", marginLeft: 'auto' }}
              onClick={() => this.ResetPass()}
            >
              بازیابی رمز عبور
            </Button>
            </view>
            {/* </div> */}
            <div>{this.SignUpcheck()}</div>
            <div>{this.check22()}</div>
            <div>{this.ForgetPassword()}</div>
            {/*<Grid container>*/}
            {/*    <Grid item xs>*/}
            {/*        <Link href="#" variant="body2">*/}
            {/*            Forgot password?*/}
            {/*        </Link>*/}
            {/*    </Grid>*/}
            {/*    <Grid item>*/}
            {/*        <Link href="#" variant="body2">*/}
            {/*            {"Don't have an account? Sign Up"}*/}
            {/*        </Link>*/}
            {/*    </Grid>*/}
            {/*</Grid>*/}
          </form>
        </div>
        <Box mt={8}>{/*<Copyright/>*/}</Box>
      </Container>
      </div>
      </div>
      {/* // </BrowserView> */}
      </ThemeProvider>
    </StylesProvider>
    );
  }
  SignUp(){
    this.setState({
      signup:true
    })
  }
  ResetPass(){
    this.setState({
      reset:true
    })
  }
  SignUpcheck(){
    if (this.state.signup){

      return (
        // <BrowserRouter>
        <Redirect
          to={{
            pathname: "/signup",
            // state: {
            //   token: this.state.token,
            //   UserName: this.state.UserName,
            // },
          }}
        />
        // </BrowserRouter>
      );
  
    }


  }
  ForgetPassword(){
    if (this.state.reset){
    return (
      // <BrowserRouter>
      <Redirect
        to={{
          pathname: "/reset_passwordreq",
          // state: {
          //   // token: this.state.token,
          //   // UserName: this.state.UserName,
          // },
        }}
      />
      // </BrowserRouter>
    );

      }
  }
  check22() {
    console.log(this.state.user_level);
    if (this.state.user_level!== "") {
      console.log(this.state.user_level);
      return (
        // <BrowserRouter>
        <Redirect
          to={{
            pathname: "/dashboard",
            state: {
              email: this.state.UserName,
              user_level: this.state.user_level,
            },
          }}
        />
        // </BrowserRouter>
      );
    }
  }

  sendLoginData() {
    // alert("hello");
//      fetch("http://conalysis.ihcs.ac.ir:8080/login", {
      fetch("http://conalysis.ihcs.ac.ir:8080/login", {

      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        UserName: this.state.UserName,
        Password: this.state.Password,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        console.log(responseJson)
        if(responseJson.status=='block'){
          // alter("username or password is wrong") 
          alert("نام کابری یا رمز عبور اشتباه است")
        }
        else if(responseJson.status=='nverified'){

          alert("حساب فعال نیست")
        }
        else{

          this.setState({
            // email: responseJson.email,
            user_level: responseJson.user_level,
          });
        }
        // console.log(responseJson);
       
        // window.location.href="/dashboard";
        // return (<Link to="/dashboard"/>);
        // alert(responseJson);
      })
      .catch((error) => { 
        console.log(error);
      });
  }
}
export default ReactFontFace(SignIn, fontConfig);
